import PropTypes from 'prop-types';
import { Helmet } from 'react-helmet-async';
import { forwardRef } from 'react';

import { IonContent, IonRefresher, IonRefresherContent } from '@ionic/react';
import { Stack } from '@mui/material';

import useAuth from '../../hooks/useAuth';
import useAppName from '../../hooks/useAppName';

const Page = forwardRef(({ children, title = '', sx, onPullRefresh, ...other }, ref) => {
  const appName = useAppName();
  const { user } = useAuth();
  const space = getPageTitle(user?.role);

  return (
    <Stack id="page" ref={ref} {...other} sx={{ ...sx, minHeight: '100%', flexGrow: 1 }}>
      <Helmet>
        <title>{`${title}${space} | ${appName}`}</title>

        {/* Chargement des fichiers statiques */}
        {!import.meta.env.DEV && !window.env.isApp && <base href="/comete_webapp/" />}

        <meta name="description" content={process.env.REACT_APP_DESC} />
        <meta name="keywords" content={process.env.REACT_APP_NAME} />
        <meta property="og:title" content={process.env.REACT_APP_NAME} />
        <meta property="og:description" content={process.env.REACT_APP_DESC} />
        <meta name="twitter:title" content={process.env.REACT_APP_NAME} />
        <meta name="twitter:description" content={process.env.REACT_APP_DESC} />
      </Helmet>

      {window.env.isApp ? (
        <IonContent className="ion-padding">
          {onPullRefresh && (
            <>
              <style>{'.spinner-circular { width: 100%; } .refresher-pulling { display: none }'}</style>
              <IonRefresher slot="fixed" style={{ zIndex: '-1', width: '100%' }} onIonRefresh={onPullRefresh}>
                <IonRefresherContent />
              </IonRefresher>
            </>
          )}
          {children}
        </IonContent>
      ) : (
        children
      )}
    </Stack>
  );
});

function getPageTitle(role) {
  let space = '';
  switch (role) {
    case 'manager':
      space = ' | Espace manager';
      break;
    case 'manager_partner':
      space = ' | Espace partenaires';
      break;
    case 'resource':
      space = ' | Espace agent';
      break;
    case 'client':
      space = ' | Espace client';
      break;
    default:
      space = '';
  }

  return space;
}

Page.propTypes = {
  children: PropTypes.node.isRequired,
  title: PropTypes.string,
  sx: PropTypes.object,
  onPullRefresh: PropTypes.func,
  colorNavarBar: PropTypes.bool
};

export default Page;
